<template>
  <div v-if="offer" class="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4">
    <div class="relative w-full max-w-md rounded-2xl overflow-hidden" style="background:#0D0F14;border:1px solid #1E2733">
      <div class="absolute inset-0 opacity-10" style="background:radial-gradient(circle at 30% 30%,#C44CB6,transparent 60%),radial-gradient(circle at 70% 70%,#4E54C8,transparent 60%)" />
      <div class="relative p-8 flex flex-col items-center text-center">
        <div class="w-full flex items-center gap-3 text-left rounded-lg border border-gray-800 bg-gray-900/70 p-3 mb-5">
          <span class="rounded-full p-[2px] flex-shrink-0" :style="{ background: offer.creator.twitch?.live ? '#E91916' : '#374151' }">
            <LanAvatar :src="offer.creator.picture_url" size="w-11 h-11 text-base border-2 border-gray-900" />
          </span>
          <div class="min-w-0 flex-1">
            <p class="text-sm font-semibold text-white">{{ offer.creator.name }}</p>
            <p v-if="offer.creator.twitch?.live" class="text-xs flex items-center gap-1.5" style="color:#BF94FF">
              {{ offer.creator.twitch.login }}
              <TwitchViewers :count="offer.creator.twitch.viewer_count" />
            </p>
            <p class="text-xs text-text-secondary">{{ $t('play.lan_party.offer_subline', { region: offer.region.name, n: offer.member_count }) }}</p>
          </div>
          <span v-if="offer.creator.twitch?.live" class="text-[11px] font-bold text-white px-1.5 py-0.5 rounded" style="background:#E91916">{{ $t('play.lan_party.live') }}</span>
        </div>
        <p class="text-xs uppercase tracking-widest mb-1 text-secondary-300">{{ offer.play_mode?.friendly_name }} • {{ $t('play.lan_party.title') }}</p>
        <h2 class="text-2xl font-bold text-white mb-2">{{ $t('play.lan_party.offer_title', { name: offer.creator.name }) }}</h2>
        <p class="text-sm text-gray-300 mb-6">{{ $t('play.lan_party.offer_body', { name: offer.creator.name }) }}</p>
        <img v-if="offer.cs_map" :src="pinUrl(offer.cs_map.name)" :alt="offer.cs_map.friendly_name" class="w-12 h-12 object-contain mb-6" />
        <div class="w-full flex flex-col gap-2">
          <button type="button" :disabled="busy" @click="accept" class="w-full py-3.5 rounded-xl font-semibold text-white flex items-center justify-center gap-2 hover:brightness-110 disabled:opacity-50" style="background:#4F5CF6">
            <CheckIcon class="w-5 h-5" aria-hidden="true" />{{ $t('play.lan_party.accept_seat') }}
          </button>
          <button type="button" :disabled="busy" @click="decline" class="w-full py-3 rounded-xl font-semibold text-text-primary bg-gray-800 hover:bg-gray-700 disabled:opacity-50">
            {{ $t('play.lan_party.decline_seat') }}
          </button>
        </div>
        <p class="text-xs mt-3 text-text-secondary">{{ $t('play.lan_party.offer_note') }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { CheckIcon } from '@heroicons/vue/20/solid';
import LanAvatar from './LanAvatar.vue';
import TwitchViewers from './TwitchViewers.vue';
import { pinUrl } from '../../utils/lan_party';
import useSeatOffer from '../../composables/useSeatOffer';

const {
  busy, offer, decline, accept,
} = useSeatOffer();
</script>
